export const CompanyData = [
  {
    value: "본사",
    child: [
      { value: "본사 공통" },
      { value: "안전환경기획팀" },
      { value: "직접입력" },
    ]
  },

  {
    value: "인천공장",
    child: [
      { value: "사업장 공통" },
      { value: "제강팀" },
      { value: "봉강생산팀" },
      { value: "설비관리팀", child: [{ value: "기계" }, { value: "전기" }] },
      { value: "노사화합팀" },
      { value: "관리팀" },
      { value: "품질관리팀" },
      { value: "안전환경팀" },
      { value: "직접입력" },
    ],
  },

  {
    value: "포항공장",
    child: [
      { value: "사업장 공통" },
      { value: "제강팀" },
      { value: "형강생산팀" },
      { value: "CS생산팀" },
      { value: "설비관리팀", child: [{ value: "기계" }, { value: "전기" }] },
      { value: "제품개발추진팀" },
      { value: "관리팀" },
      { value: "품질관리팀" },
      { value: "안전환경팀" },
      { value: "물류팀" },
      { value: "직접입력" },
    ],
  },

  {
    value: "당진공장",
    child: [
      { value: "사업장 공통" },
      { value: "후판생산팀" },
      { value: "설비관리팀" },
      { value: "관리팀" },
      { value: "품질관리팀" },
      { value: "안전환경팀" },
      { value: "직접입력" },
    ],
  },

  {
    value: "중앙기술연구소",
    child: [
      { value: "사업장 공통" },
      { value: "연구지원팀" },
      { value: "직접입력" },
    ],
  },

  {
    value: "수급업체",
    child: [
      { value: "직접입력" },
    ],
  }
]
